import { Component, effect, inject } from '@angular/core';
import { SeoService } from '../core/seo.service';
import { SiteConfigService } from '../core/site-config.service';
import { FeedsWidgetComponent } from '../widgets/feeds/feeds-widget.component';
import { I18nService } from '../core/i18n.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-feeds-page',
  imports: [FeedsWidgetComponent],
  template: `<app-feeds-widget [feedID]="feedID" [watchMode]="feedID > 0" />`
})
export class FeedsPage {
  private readonly seo = inject(SeoService);
  private readonly site = inject(SiteConfigService);
  private readonly i18n = inject(I18nService);
  protected readonly feedID = Number(inject(ActivatedRoute).snapshot.paramMap.get('id') ?? 0);

  constructor() {
    effect(() => {
      const falDeryasi = this.site.experience('fortune');
      const umutDemir = this.site.config().brandKey === 'umutdemironline';
      const fmos = this.site.config().brandKey === 'fmoshair';
      const utku = this.site.config().brandKey === 'utkusahincoiffeur';
      const falCopy = {
        tr: ['Falcı akışı ve canlı yayınlar', 'Fal Deryası akışında falcıların paylaşımlarını, canlı yayınlarını, yorumlarını ve fal seçeneklerini takip et.'],
        en: ['Reader feed and live sessions', 'Follow reader posts, live sessions, comments and reading options in the Fal Deryası feed.'],
        de: ['Berater-Feed und Live-Sitzungen', 'Verfolge Beiträge, Live-Sitzungen, Kommentare und Deutungsangebote im Fal Deryası Feed.'],
        es: ['Feed de videntes y directos', 'Sigue publicaciones, directos, comentarios y lecturas en el feed de Fal Deryası.'],
        fr: ['Fil des voyants et directs', 'Suivez les publications, directs, commentaires et voyances dans le fil Fal Deryası.']
      }[this.i18n.lang()];
      if (this.feedID > 0) return;
      this.seo.setPage({
        title: falDeryasi ? falCopy[0] : umutDemir ? 'Stil günlüğü | Umut Demir' : fmos ? 'Stil günlüğü | FMOS Hair' : utku ? 'Dönüşümler | Utku Şahin Coiffeur' : 'Satıcı akışı',
        description: falDeryasi
          ? falCopy[1]
          : umutDemir
            ? 'Umut Demir ekibinin kesim, renklendirme ve saç bakımı çalışmalarından güncel dönüşümleri ve stil ilhamını keşfet.'
            : fmos
              ? 'FMOS Hair ekibinin renklendirme, kesim, bakım ve saç tasarımı çalışmalarından güncel görünümleri keşfet.'
            : utku
              ? 'Utku Şahin Coiffeur mikro ve medikal kaynak, renklendirme ve saç tasarımı çalışmalarından gerçek sonuçları keşfet.'
            : 'Aymudo satici akisinda paylasimlari, videolari ve canli yayinlari kesfet.',
        path: falDeryasi || umutDemir || fmos || utku ? '/akis' : '/feed'
      });
    });
  }
}
